var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmacaoCadastro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3446 35.1359C76.4743 36.0595 76.5761 37.6505 75.5719 38.6896L46.3789 68.8962C45.8595 69.4336 45.1151 69.7411 44.3334 69.7411C43.5516 69.7411 42.8072 69.4336 42.2878 68.8962L27.6913 53.7929C26.6871 52.7538 26.7889 51.1628 27.9186 50.2392C29.0483 49.3156 30.7782 49.4091 31.7824 50.4482L44.3334 63.435L71.4808 35.3449C72.485 34.3058 74.2149 34.2122 75.3446 35.1359Z",
    fill: "#0E8750"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52.5,
    r: 50,
    stroke: "#0E8750",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmacaoCadastro);
export default __webpack_public_path__ + "static/media/confirmacaoCadastro.d3966f135accfdae4565d0b5a9ae6889.svg";
export { ForwardRef as ReactComponent };